import { useMemo } from 'react'

import { JSONType, Maybe, Scalars } from '@Generated/graphql'

function getHeight(cardAspectRatio: string, width: number): number {
  if (cardAspectRatio === 'portrait') {
    return width * 1.5
  }

  return width
}

function getWidth(cardSize: string, cardVariant: string): number {
  if (cardVariant === 'spot') {
    if (cardSize === 'tiny') {
      return 80
    }

    return 120
  }

  if (cardSize === 'medium') {
    return 370
  }

  if (cardSize === 'half') {
    return 1024
  }

  if (cardSize === 'tiny') {
    return 60
  }

  return 370
}

function parseStringSetting(value: JSONType, defaultValue: string): string {
  if (typeof value === 'string') {
    return value
  }

  return defaultValue
}

export function useTileSettings(settingsRaw?: Maybe<Scalars['JSON']>) {
  return useMemo(() => {
    const settings = typeof settingsRaw === 'object' && !Array.isArray(settingsRaw) ? settingsRaw || {} : {}

    const result = {
      cardAspectRatio: parseStringSetting(settings.cardAspectRatio, 'square'),
      cardSize: parseStringSetting(settings.cardSize, 'medium'),
      cardVariant: parseStringSetting(settings.cardVariant, 'background'),
      enableSlider: typeof settings.enableSlider === 'boolean' ? settings.enableSlider : false,
      rowsDesktop: typeof settings.rowsDesktop === 'number' || typeof settings.rowsDesktop === 'string' ? settings.rowsDesktop : 'auto',
      rowsMobile: typeof settings.rowsMobile === 'number' || typeof settings.rowsMobile === 'string' ? settings.rowsMobile : 'auto',
    }

    const width = getWidth(result.cardSize, result.cardVariant)

    return {
      ...result,
      height: getHeight(result.cardAspectRatio, width),
      width,
    }
  }, [settingsRaw])
}

export type TileSettings = ReturnType<typeof useTileSettings>
